// @flow
import React from 'react';

// TODO: refactor this, its better to create a single component to manage the report buttons

import styles from './reportAssitanceCard.css';
import Card from '../Card';
import CardHeader from '../CardHeader';
import CardContent from '../CardContent';
import CardHeaderTitleContainer from '../CardHeaderTitleContainer';
import CardHeaderTitle from '../CardHeaderTitle';


// type ReportAssistanceCardPropTypes = {};

const ReportAssistanceCard = () => (
  <Card isRound isClickeable>
    <CardHeader size="small">
      <CardHeaderTitleContainer>
        <CardHeaderTitle title="Asistencia por ruta" size="small" />
      </CardHeaderTitleContainer>
    </CardHeader>
    <CardContent className="medium">
      <div className={styles.content}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Maecenas consequat a lorem id gravida. Morbi eu lacus
      </div>
    </CardContent>
  </Card>
);

export default ReportAssistanceCard;



// WEBPACK FOOTER //
// ./src/scripts/components/ReportAssistanceCard/index.jsx